import { makeStyles, Text, Button, Link } from '@fluentui/react-components';
import { MailIcon, PhishedLogoIcon } from '@utils-global';
import { useIsV2 } from '@data';
import { useAutofocus } from '@utils';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '16px',
  },
  v2Wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '16px',
    background: 'linear-gradient(to bottom right, #091731, #1D305A)',
    minHeight: '100vh',
    width: '100%',
  },
  v2Title: {
    color: '#ffffff',
    marginTop: '16px',
    marginBottom: '8px',
    textAlign: 'center',
  },
  v2Subtitle: {
    color: '#ffffff',
    textAlign: 'center',
  },
  title: {
    marginTop: '16px',
    marginBottom: '8px',
    textAlign: 'center',
  },
  subtitle: {
    textAlign: 'center',
  },
  button: {
    marginTop: '16px',
    backgroundColor: '#50BCBD',
    width: '100%',
    padding: '10px',
  },
  link: {
    marginTop: '20px',
    textAlign: 'center',
    color: '#50BCBD',
  },
});

type LoginScreenProps = {
  onLogin: () => void;
  isLoginDisabled: boolean;
};

export const LoginScreen = ({ onLogin, isLoginDisabled }: LoginScreenProps) => {
  const styles = useStyles();
  const { t } = useTranslation();
  const { targetRef } = useAutofocus();
  const isV2 = useIsV2();
  const textColor = isV2 ? undefined : '#14141E';

  return (
    <section
      aria-label="Login page"
      className={isV2 ? styles.v2Wrapper : styles.wrapper}
      tabIndex={-1}
      ref={targetRef}
    >
      <PhishedLogoIcon aria-hidden="true" />
      <MailIcon aria-hidden="true" />
      <Text
        color={textColor}
        size={500}
        weight="bold"
        role="heading"
        className={isV2 ? styles.v2Title : styles.title}
      >
        {t(isV2 ? 'loginPage.titleV2' : 'loginPage.title')}
      </Text>
      <Text
        color={textColor}
        size={300}
        weight="bold"
        className={isV2 ? styles.v2Subtitle : styles.subtitle}
      >
        {t('loginPage.subtitle')}
      </Text>
      <Button
        id="login-button"
        appearance="primary"
        className={styles.button}
        onClick={onLogin}
        disabled={isLoginDisabled}
      >
        {t('loginPage.button')}
      </Button>
      <Link
        className={styles.link}
        id="phished-website-link"
        href="https://phished.io/"
        target="_blank"
      >
        <Text color="#50BCBD" size={300} weight="semibold">
          {t('loginPage.link')}
        </Text>
      </Link>
    </section>
  );
};
